// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetFeatureFlagGroupsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import FeatureFlagGroupDTO from '../models/FeatureFlagGroupDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    featureFlagArea: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            featureFlagArea: "",
        },
        initValues);
    },
    featureFlagArea: 'featureFlagArea',
}

interface Result extends ResultDTO {
    featureFlagGroups: FeatureFlagGroupDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            featureFlagGroups: [],
        },
        initValues);
    },
    featureFlagGroups: 'featureFlagGroups',
}

export { Request, Result };